
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class EmptyState extends Vue {
  @Prop({ default: '提示' }) public title!: string
  @Prop({ default: '暂无数据' }) public description!: string
  @Prop({ default: 'info' }) public type!: string
}
